import { apiService } from "./apiService";
import { getAccessToken } from "./authService";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api";

/**
 * Drop empty values so the backend only receives the filters actually in use.
 */
const buildQueryString = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || value === "all") {
      return;
    }
    params.append(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

export const getLoginAuditLogs = async (filters = {}) => {
  return apiService.request(`/super-admin/login-audit${buildQueryString(filters)}`, {
    method: "GET",
  });
};

export const getLoginAuditStats = async (filters = {}) => {
  return apiService.request(
    `/super-admin/login-audit/stats${buildQueryString(filters)}`,
    { method: "GET" }
  );
};

export const exportLoginAuditLogs = async (filters = {}) => {
  const token = getAccessToken();
  const response = await fetch(
    `${API_BASE_URL}/super-admin/login-audit/export${buildQueryString(filters)}`,
    {
      method: "GET",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );

  if (!response.ok) {
    throw new Error("Failed to export login audit logs");
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `login-audit-logs-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
